import { Button } from '../../components';
import React from 'react';
import { ChannelInfoService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchChannelList: any;
}

const ChannelManagementDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchChannelList,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const deleteService = () => {
    ChannelInfoService.deleteChannelApi(id).then(() => {
      setDeleted(true);
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete Report
          </h2>
          <p>
            Are you sure you want to delete this report?
          </p>
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Report deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchChannelList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default ChannelManagementDelete;
